import { Button, ButtonProps } from '@mui/material';
import { JSX } from 'react';
import clsx from 'clsx';

interface DataGridSelectActionProps extends ButtonProps {
  /**
   * Flag indicating if the button is active
   * @default false
   */
  active?: boolean;
}

/**
 * Select button for DataGrid row actions
 */
const DataGridSelectAction = ({ active, ...props }: DataGridSelectActionProps): JSX.Element => (
  <Button
    {...props}
    variant={active ? 'contained' : 'outlined'}
    className={clsx(active && 'active')}
  >
    {active ? 'Selected' : 'Select'}
  </Button>
);

export default DataGridSelectAction;
